import { NextUI } from '@/components/NextUI';
import { Card, CardBody, CardFooter, CardHeader } from "@heroui/card";
import clsx from 'clsx';
import React, { ForwardedRef } from 'react';
import { useFormStatus } from 'react-dom';

const FormCard = React.forwardRef(
  (
    {
      children,
      actionText,
      description,
      isAction = true,
      ...props
    }: {
      actionText?: string;
      description?: string | React.ReactNode;
      isAction?: boolean;
      classNames?: {
        actionWrapper?: string;
        actionButton?: string;
        formBody?: string;
      };
    } & React.ComponentProps<typeof Card>,
    ref: ForwardedRef<HTMLFormElement>
  ) => {
    return (
      <NextUI.Card
        as="form"
        shadow="none"
        radius="none"
        ref={ref as any}
        className={clsx(props.className)}
        {...props}
      >
        {description && (
          <CardHeader className="!p-0 pb-0 justify-center text-soft-title font-light font-poppins text-sm">
            {React.isValidElement(description) ? (
              description
            ) : (
              <p>{description}</p>
            )}
          </CardHeader>
        )}
        <CardBody
          className={clsx(
            ' overflow-hidden !rounded-none',
            props.classNames?.formBody
          )}
        >
          {children}
        </CardBody>
        {isAction && (
          <CardFooter
            className={clsx(
              '!p-0 pt-0 justify-center',
              props.classNames?.actionWrapper
            )}
          >
            <FormActionButton
              actionText={actionText}
              className={props.classNames?.actionButton}
            />
          </CardFooter>
        )}
      </NextUI.Card>
    );
  }
);

FormCard.displayName = 'FormCard';

function FormActionButton(props: { actionText?: string; className?: string }) {
  const { pending } = useFormStatus();
  return (
    <NextUI.Button
      isLoading={pending}
      className={clsx('w-60 h-[47px]', props.className)}
      type="submit"
    >
      {props.actionText}
    </NextUI.Button>
  );
}

export default FormCard;
